module.exports = __webpack_public_path__ + "img/2-5.d7dc2a72.png";